/**
 * Flag assets in static/images/flags/ (filename stem → URL path).
 * Category markers only render when the category slug resolves here.
 */
const FLAG_FILES: Record<string, string> = {
  andorra: "andorra.svg",
  austria: "austria.svg",
  belgium: "belgium.svg",
  "czech-republic": "czech-republic.svg",
  denmark: "denmark.svg",
  england: "england.svg",
  france: "france.svg",
  germany: "germany.svg",
  greece: "greece.svg",
  ireland: "ireland.svg",
  italy: "italy.svg",
  netherlands: "netherlands.svg",
  poland: "poland.svg",
  portugal: "portugal.svg",
  scotland: "scotland.svg",
  slovakia: "slovakia.svg",
  slovenia: "slovenia.svg",
  spain: "spain.svg",
  sweden: "Sweden.svg", // file is capitalized on disk
  switzerland: "switzerland.svg",
  wales: "wales.svg",
  sk: "sk.svg",
};

/**
 * @returns public URL for the flag, or null if no asset for this slug
 */
export function resolveFlagSrc(slug: string | null | undefined): string | null {
  if (!slug) return null;
  const key = slug.toLowerCase();
  const file = FLAG_FILES[key];
  if (!file) return null;
  return `/images/flags/${file}`;
}

export function hasFlagAsset(slug: string | null | undefined): boolean {
  return resolveFlagSrc(slug) != null;
}
